module.exports = __webpack_public_path__ + "assets/header_triangle_button-13bd22.svg";